import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { useReports } from "@/profitability/report-query";
import type { ProfitabilityRun } from "@/profitability/types";
import { RunDocumentCard } from "./run-document-card";

export const RunDocuments = ({
  businessId,
  run,
}: {
  businessId: string;
  run: Pick<
    ProfitabilityRun,
    "documents" | "inputs" | "report" | "matched_columns" | "workflow_version"
  >;
}) => {
  const reports = useReports(
    run.report ? businessId : null,
    run.workflow_version,
  );
  const slots =
    reports.data?.find((report) => report.id === run.report?.id)?.inputs ?? [];
  const slotTitle = (documentId: string) => {
    const key = Object.entries(run.inputs ?? {}).find(
      ([, id]) => id === documentId,
    )?.[0];
    if (!key) return null;
    return slots.find((slot) => slot.key === key)?.title ?? key;
  };

  if (!run.documents?.length)
    return (
      <Text tone="muted" className="py-6">
        This run read no documents.
      </Text>
    );

  return (
    <Stack className="w-full" gap={6} align="stretch">
      {run.documents.map((document) => (
        <RunDocumentCard
          key={document.id}
          document={document}
          slotTitle={slotTitle(document.id)}
          matches={(run.matched_columns ?? []).filter(
            (match) => match.document_id === document.id,
          )}
        />
      ))}
    </Stack>
  );
};
